import { createAction, props } from '@ngrx/store';

export const success = createAction(
    '[Notification] Success',
    props<{ message: string }>()
);

export const failure = createAction(
    '[Notification] Failure',
    props<{ message: string }>()
);


export type Actions = ReturnType<
    | typeof success
    | typeof failure
>;



